<template>
  <section
    id="voice"
    class="co-bg-striped"
  >
    <div class="co-container-xs px-4 pb-[3.25rem] pt-20">
      <h2 class="co-heading-2">
        受講生の声
      </h2>
      <Swiper
        :modules="[SwiperPagination]"
        :slides-per-view="1"
        :pagination="{
          clickable: true,
        }"
        class="!pr-0"
      >
        <SwiperSlide
          :key="1"
          class="!h-auto"
        >
          <div
            class="h-full bg-white p-6 shadow sm:p-10 md:p-[3.75rem]"
          >
            <em class="co-display-11">
              <span>カリキュラムが基礎をずっと勉強するのではなく、基礎を元に成果物を作るというマイルストーンが細かく設定されていたので、</span>
              <span>開発できた時の達成感がありました。先の目標が見えたのがすごくよかったです。</span>
            </em>
            <div class="mt-5 flex justify-center sm:mt-10">
              <div class="mr-4">
                <img
                  class="rounded-full"
                  src="~/assets/images/Te/TeCommon/Slider/Voice/student-yoshida.jpg"
                  alt="吉田 祐輔さん"
                  width="60"
                  height="60"
                >
              </div>
              <div>
                <p class="mb-0 font-bold text-co-gray-600">
                  吉田 祐輔さん
                </p>
                <p class="co-display-12">
                  メディア運営
                </p>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide
          :key="2"
          class="!h-auto"
        >
          <div
            class="h-full bg-white p-6 shadow sm:p-10 md:p-[3.75rem]"
          >
            <em class="co-display-11">
              テックアカデミーは1人で学習していると解決できないようなつまずきや、些細な疑問に対しても、現役のプロのメンターがいつでも親身に答えてくれて私でも理解できました。
            </em>
            <div class="mt-5 flex justify-center sm:mt-10">
              <div class="mr-4">
                <img
                  class="rounded-full"
                  src="~/assets/images/Te/TeCommon/Slider/Voice/student-kurihara.jpg"
                  alt="栗原 真沙美さん"
                  width="60"
                  height="60"
                >
              </div>
              <div>
                <p class="mb-0 font-bold text-co-gray-600">
                  栗原 真沙美さん
                </p>
                <p class="co-display-12">
                  大学生
                </p>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide
          :key="3"
          class="!h-auto"
        >
          <div
            class="h-full bg-white p-6 shadow sm:p-10 md:p-[3.75rem]"
          >
            <em class="co-display-11">
              独学はかなり難しいし、サポートが無いと前に進めないことが多い。
              厚めの参考書読んだり書いたりしてなんとなく出来たと満足しているよりは、
              短期集中で学習する方が身につくと感じました。
            </em>
            <div class="mt-5 flex justify-center sm:mt-10">
              <div class="mr-4">
                <img
                  class="rounded-full"
                  src="~/assets/images/Te/TeCommon/Slider/Voice/student-sano.jpg"
                  alt="佐野 創一さん"
                  width="60"
                  height="60"
                >
              </div>
              <div>
                <p class="mb-0 font-bold text-co-gray-600">
                  佐野 創一さん
                </p>
                <p class="co-display-12">
                  システム会社勤務
                </p>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide
          :key="4"
          class="!h-auto"
        >
          <div
            class="h-full bg-white p-6 shadow sm:p-10 md:p-[3.75rem]"
          >
            <em class="co-display-11">
              パーソナルメンターが熱心だったので、それに答えなきゃいけないという気持ちがわいてきました。
              次のメンタリングでなんとか出来ましたよっていう報告ができないと、申し訳ないと思ってしまう気持ちで頑張りました。
            </em>
            <div class="mt-5 flex justify-center sm:mt-10">
              <div class="mr-4">
                <img
                  class="rounded-full"
                  src="~/assets/images/Te/TeCommon/Slider/Voice/student-nishida.jpg"
                  alt="西田 稔さん"
                  width="60"
                  height="60"
                >
              </div>
              <div>
                <p class="mb-0 font-bold text-co-gray-600">
                  西田 稔さん
                </p>
                <p class="co-display-12">
                  建築関連会社勤務
                </p>
              </div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  </section>
</template>

<style scoped>
@import url('~/assets/css/Te/TeCommon/TeCommonSwiper.css');
</style>
